import styled from 'styled-components';

import { getInnerPadding } from './helpers';

import { IIcon } from './types';
import { Theme } from '../types';

const getFill = ({
    theme,
    secondary,
    focused,
    disabled,
}: {
    theme: Theme;
    secondary?: boolean;
    focused?: boolean;
    disabled?: boolean;
}) => {
    if (secondary) return theme['action-secondary'];
    if (focused) return theme['action-pressed'];
    if (disabled) return theme['action-disabled'];

    return theme['action-main'];
};

export const Container = styled.div<IIcon>`
    ${({ mb }) => mb && `margin-bottom: ${mb}px;`};
    ${({ size }) =>
        size &&
        `padding: ${getInnerPadding(size)};
        width: ${size}px; height: ${size}px;
    `}

    svg {
        width: 100%;
        height: 100%;
        fill: ${({ theme, libColor }) => theme[libColor || 'text-main']};

        * {
            fill: ${({ theme, libColor }) => theme[libColor || 'text-main']};
        }
    }

    ${({ type, theme, focused, disabled, secondary }) =>
        type === 'actionable' &&
        `
        * {
            fill: ${getFill({ theme, focused, disabled, secondary })} !important;
        }
        
        &:hover * {
            fill: ${theme['action-hovered']}
        }
       
        &:active * {
            fill: ${theme['action-pressed']}
        }
      `}
`;
